import { Forms } from '@/types/forms/forms';
import { CombinedVueInstance } from 'vue/types/vue';
import { ValidationRule } from 'vuelidate/lib/validators';

/**
 * Validates that the form list of rcdin's doesn't end up having additional but empty fields,
 * though the field is inherintly optional, as long as no information is provided at all
 */
export const registeredConsumptionDeviceIdentificationNumbers = function <
    Instance extends Vue
>(
    this: CombinedVueInstance<
        Instance,
        { model: Forms },
        unknown,
        unknown,
        unknown
    >,
) {
    const numbers = this.model.application.controllableConsumptionDevices.identificationNumbersOfRegisteredConsumptionDevices.items.map(
        (item) => item.value,
    );

    if (!numbers || !Array.isArray(numbers) || numbers.length <= 1) {
        return true;
    }

    return numbers.every(
        (val) =>
            val !== undefined &&
            val !== null &&
            (typeof val !== 'string' || val !== ''),
    );
} as ValidationRule;
